import { VestmentCategory } from '../../enum/vestmentCategory';
import AlbItemDialogContent from '../../pages/OrderForm/AlbItemDialog';
import ChasubleItemDialogContent from '../../pages/OrderForm/ChasubleItemDialog';
import MitreItemDialogContent from '../../pages/OrderForm/MitreItemDialog';
import StoleItemDialogContent from '../../pages/OrderForm/StoleItemDialog';
import type { OrderItemCategoryDialog } from './types';

export const ORDER_ITEM_DIALOGS: Record<
  VestmentCategory,
  OrderItemCategoryDialog
> = {
  [VestmentCategory.Chasuble]: ChasubleItemDialogContent,
  [VestmentCategory.Alb]: AlbItemDialogContent,
  [VestmentCategory.Stole]: StoleItemDialogContent,
  [VestmentCategory.Mitre]: MitreItemDialogContent,
};
